module.exports = __webpack_public_path__ + "static/media/close-icon.91bdc8b8.svg";